<template>
    <div id="app">
        <router-view name="header"/>
        <div>
            <router-view/>
        </div>
        <router-view name="footer"/>
    </div>
</template>
<script>
    //import {texts} from '@/constants/texts'
    export default {
        name: 'App',
        /*computed: {
            constTxts() {
                return texts
            }
        },*/
        metaInfo: {
            titleTemplate: '%s | ' + 'All Nations Convocation Jerusalem 2021 | Live | JHOPFAN',
            meta: [
                { name: 'description', content: 'Join us live online for the All Nations Convocation Jerusalem 2021.' },
                { name: 'og:title', content: 'All Nations Convocation Jerusalem 2021 | Live | JHOPFAN' },
                { name: 'og:description', content: 'Join us live online for the All Nations Convocation Jerusalem 2021.' },
                { name: 'og:image', content: 'https://live.jhopfan.org/img/sarel/JHOPFAN-icon-with-text.svg' },
            ],
        },
    }
</script>

